import {PaymentMethodSetupInfo} from '@adyen/api-library/lib/src/typings/management/paymentMethodSetupInfo';
import {ExtendedPaymentMethodEnum, ExtendedPaymentMethodType} from '../types';

export enum PaymentMethodVariantEnum {
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  ach = 'ach',
  // biome-ignore lint/style/useNamingConvention: <explanation>
  ach_plaid = 'ach_plaid',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  amex = 'amex',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  amex_amazonpay = 'amex_amazonpay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  amex_googlepay = 'amex_googlepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  amex_applepay = 'amex_applepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  amex_samsungpay = 'amex_samsungpay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  amex_vipps = 'amex_vipps',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  amex_mobilepay = 'amex_mobilepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  amexcommercial = 'amexcommercial',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  amexconsumer = 'amexconsumer',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  amexcorporate = 'amexcorporate',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  amexdebit = 'amexdebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  amexprepaid = 'amexprepaid',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  amexprepaidreloadable = 'amexprepaidreloadable',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  amexsmallbusiness = 'amexsmallbusiness',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  discover = 'discover',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  discover_amazonpay = 'discover_amazonpay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  discover_googlepay = 'discover_googlepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  discover_applepay = 'discover_applepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  discover_samsungpay = 'discover_samsungpay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mc = 'mc',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mc_amazonpay = 'mc_amazonpay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mc_googlepay = 'mc_googlepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mc_applepay = 'mc_applepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mc_samsungpay = 'mc_samsungpay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mc_vipps = 'mc_vipps',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mc_mobilepay = 'mc_mobilepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mcalphabankbonus = 'mcalphabankbonus',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mcatm = 'mcatm',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mccommercialcredit = 'mccommercialcredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mccommercialdebit = 'mccommercialdebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mccommercialpremiumcredit = 'mccommercialpremiumcredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mccommercialpremiumdebit = 'mccommercialpremiumdebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mccorporate = 'mccorporate',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mccorporatecredit = 'mccorporatecredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mccorporatedebit = 'mccorporatedebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mccredit = 'mccredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mcdebit = 'mcdebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mcfleetcredit = 'mcfleetcredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mcfleetdebit = 'mcfleetdebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mcpremiumcredit = 'mcpremiumcredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mcpremiumdebit = 'mcpremiumdebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mcprepaidanonymous = 'mcprepaidanonymous',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mcpro = 'mcpro',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mcpurchasingcredit = 'mcpurchasingcredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mcpurchasingdebit = 'mcpurchasingdebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mcstandardcredit = 'mcstandardcredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mcstandarddebit = 'mcstandarddebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mcsuperpremiumcredit = 'mcsuperpremiumcredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  mcsuperpremiumdebit = 'mcsuperpremiumdebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visa = 'visa',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visa_amazonpay = 'visa_amazonpay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visa_googlepay = 'visa_googlepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visa_applepay = 'visa_applepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visa_samsungpay = 'visa_samsungpay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visa_vipps = 'visa_vipps',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visa_mobilepay = 'visa_mobilepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visaalphabankbonus = 'visaalphabankbonus',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visabusiness = 'visabusiness',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visacheckout = 'visacheckout',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visaclassic = 'visaclassic',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visacommercialcredit = 'visacommercialcredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visacommercialdebit = 'visacommercialdebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visacommercialpremiumcredit = 'visacommercialpremiumcredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visacommercialpremiumdebit = 'visacommercialpremiumdebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visacommercialsuperpremiumcredit = 'visacommercialsuperpremiumcredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visacommercialsuperpremiumdebit = 'visacommercialsuperpremiumdebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visacorporate = 'visacorporate',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visacorporatecredit = 'visacorporatecredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visacorporatedebit = 'visacorporatedebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visacredit = 'visacredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visadankort = 'visadankort',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visadankort_mobilepay = 'visadankort_mobilepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visadebit = 'visadebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visafleetcredit = 'visafleetcredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visafleetdebit = 'visafleetdebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visagold = 'visagold',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visahipotecario = 'visahipotecario',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visaplatinum = 'visaplatinum',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visapremiumcredit = 'visapremiumcredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visapremiumdebit = 'visapremiumdebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visaprepaidanonymous = 'visaprepaidanonymous',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visaproprietary = 'visaproprietary',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visapurchasing = 'visapurchasing',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visapurchasingcredit = 'visapurchasingcredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visapurchasingdebit = 'visapurchasingdebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visasaraivacard = 'visasaraivacard',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visasignature = 'visasignature',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visastandardcredit = 'visastandardcredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visastandarddebit = 'visastandarddebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visasuperpremiumcredit = 'visasuperpremiumcredit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  visasuperpremiumdebit = 'visasuperpremiumdebit',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  vpay = 'vpay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  electron = 'electron',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  electron_amazonpay = 'electron_amazonpay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  electron_applepay = 'electron_applepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  electron_samsungpay = 'electron_samsungpay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  electron_vipps = 'electron_vipps',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  electron_mobilepay = 'electron_mobilepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  interac = 'interac',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  interac_applepay = 'interac_applepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  interac_card = 'interac_card',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  interac_googlepay = 'interac_googlepay',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  paypal = 'paypal',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  paypal_pos = 'paypal_pos',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  paysafecard = 'paysafecard',
  // biome-ignore lint/style/useNamingConvention: enum key is snake_case or lowercase to match external identifiers
  directdebit_GB = 'directdebit_GB',
}

export type PaymentMethodVariantType =
  (typeof PaymentMethodVariantEnum)[keyof typeof PaymentMethodVariantEnum];

export const paymentMethodVariantTranslationMap: Record<string, string> = {
  [PaymentMethodVariantEnum.directdebit_GB]: 'BACS Direct Debit',
  [PaymentMethodVariantEnum.amex_amazonpay]: 'Amazon Pay – American Express',
  [PaymentMethodVariantEnum.amex_googlepay]: 'Google Pay - American Express',
  [PaymentMethodVariantEnum.amex_applepay]: 'Apple Pay - American Express',
  [PaymentMethodVariantEnum.amex_samsungpay]: 'Samsung Pay - American Express',
  [PaymentMethodVariantEnum.amex_vipps]: 'Vipps - American Express',
  [PaymentMethodVariantEnum.amex_mobilepay]: 'MobilePay - American Express',
  [PaymentMethodVariantEnum.amexcommercial]: 'American Express Commercial Credit Card',
  [PaymentMethodVariantEnum.amexconsumer]: 'American Express Consumer Credit Card',
  [PaymentMethodVariantEnum.amexcorporate]: 'American Express Corporate Credit Card',
  [PaymentMethodVariantEnum.amexdebit]: 'American Express Debit Card',
  [PaymentMethodVariantEnum.amexprepaid]: 'American Express Prepaid Card',
  [PaymentMethodVariantEnum.amexprepaidreloadable]: 'American Express Prepaid-Reloadable Card',
  [PaymentMethodVariantEnum.amexsmallbusiness]: 'American Express Small Business Credit Card',
  [PaymentMethodVariantEnum.discover_amazonpay]: 'Amazon Pay - Discover',
  [PaymentMethodVariantEnum.discover_googlepay]: 'Google Pay - Discover',
  [PaymentMethodVariantEnum.discover_applepay]: 'Apple Pay - Discover',
  [PaymentMethodVariantEnum.discover_samsungpay]: 'Samsung Pay - Discover',
  [PaymentMethodVariantEnum.mc_amazonpay]: 'Amazon Pay - Mastercard',
  [PaymentMethodVariantEnum.mc_googlepay]: 'Google Pay - Mastercard',
  [PaymentMethodVariantEnum.mc_applepay]: 'Apple Pay - Mastercard',
  [PaymentMethodVariantEnum.mc_samsungpay]: 'Samsung Pay - Mastercard',
  [PaymentMethodVariantEnum.mc_vipps]: 'Vipps - Mastercard',
  [PaymentMethodVariantEnum.mc_mobilepay]: 'MobilePay - Mastercard',
  [PaymentMethodVariantEnum.mcalphabankbonus]: 'Mastercard Alpha Bank Bonus',
  [PaymentMethodVariantEnum.mcatm]: 'Mastercard ATM',
  [PaymentMethodVariantEnum.mccommercialcredit]: 'Mastercard Commercial Credit',
  [PaymentMethodVariantEnum.mccommercialdebit]: 'Mastercard Commercial Debit',
  [PaymentMethodVariantEnum.mccommercialpremiumcredit]: 'Mastercard Commercial Premium Credit',
  [PaymentMethodVariantEnum.mccommercialpremiumdebit]: 'Mastercard Commercial Premium Debit',
  [PaymentMethodVariantEnum.mccorporate]: 'Mastercard Corporate',
  [PaymentMethodVariantEnum.mccorporatecredit]: 'Mastercard Corporate Credit',
  [PaymentMethodVariantEnum.mccorporatedebit]: 'Mastercard Corporate Debit',
  [PaymentMethodVariantEnum.mccredit]: 'Mastercard Credit',
  [PaymentMethodVariantEnum.mcfleetcredit]: 'Mastercard Fleet Credit',
  [PaymentMethodVariantEnum.mcfleetdebit]: 'Mastercard Fleet Debit',
  [PaymentMethodVariantEnum.mcpremiumcredit]: 'Mastercard Premium Credit',
  [PaymentMethodVariantEnum.mcpremiumdebit]: 'Mastercard Premium Debit',
  [PaymentMethodVariantEnum.mcprepaidanonymous]: 'Mastercard Prepaid Anonymous',
  [PaymentMethodVariantEnum.mcpro]: 'Mastercard Pro',
  [PaymentMethodVariantEnum.mcpurchasingcredit]: 'Mastercard Purchasing Credit',
  [PaymentMethodVariantEnum.mcpurchasingdebit]: 'Mastercard Purchasing Debit',
  [PaymentMethodVariantEnum.mcstandardcredit]: 'Mastercard Standard Credit',
  [PaymentMethodVariantEnum.mcstandarddebit]: 'Mastercard Standard Debit',
  [PaymentMethodVariantEnum.mcsuperpremiumcredit]: 'Mastercard Super Premium Credit',
  [PaymentMethodVariantEnum.mcsuperpremiumdebit]: 'Mastercard Super Premium Debit',
  [PaymentMethodVariantEnum.visa_amazonpay]: 'Amazon Pay - Visa',
  [PaymentMethodVariantEnum.visa_googlepay]: 'Google Pay - Visa',
  [PaymentMethodVariantEnum.visa_applepay]: 'Apple Pay - Visa',
  [PaymentMethodVariantEnum.visa_samsungpay]: 'Samsung Pay - Visa',
  [PaymentMethodVariantEnum.visa_vipps]: 'Vipps - Visa',
  [PaymentMethodVariantEnum.visa_mobilepay]: 'MobilePay - Visa',
  [PaymentMethodVariantEnum.visaalphabankbonus]: 'Visa Alpha Bank Bonus',
  [PaymentMethodVariantEnum.visabusiness]: 'Visa Business',
  [PaymentMethodVariantEnum.visacheckout]: 'Visa Checkout',
  [PaymentMethodVariantEnum.visaclassic]: 'Visa Classic',
  [PaymentMethodVariantEnum.visacommercialcredit]: 'Visa Commercial Credit',
  [PaymentMethodVariantEnum.visacommercialdebit]: 'Visa Commercial Debit',
  [PaymentMethodVariantEnum.visacommercialpremiumcredit]: 'Visa Commercial Premium Credit',
  [PaymentMethodVariantEnum.visacommercialpremiumdebit]: 'Visa Commercial Premium Debit',
  [PaymentMethodVariantEnum.visacommercialsuperpremiumcredit]:
    'Visa Commercial Super Premium Credit',
  [PaymentMethodVariantEnum.visacommercialsuperpremiumdebit]: 'Visa Commercial Super Premium Debit',
  [PaymentMethodVariantEnum.visacorporate]: 'Visa Corporate',
  [PaymentMethodVariantEnum.visacorporatecredit]: 'Visa Corporate Credit',
  [PaymentMethodVariantEnum.visacorporatedebit]: 'Visa Corporate Debit',
  [PaymentMethodVariantEnum.visacredit]: 'Visa credit card',
  [PaymentMethodVariantEnum.visadankort]: 'Visa Dankort',
  [PaymentMethodVariantEnum.visadankort_mobilepay]: 'MobilePay - Visa Dankort',
  [PaymentMethodVariantEnum.visafleetcredit]: 'Visa Fleet Credit',
  [PaymentMethodVariantEnum.visafleetdebit]: 'Visa Fleet Debit',
  [PaymentMethodVariantEnum.visagold]: 'Visa Gold',
  [PaymentMethodVariantEnum.visahipotecario]: 'Visa Hipotecario',
  [PaymentMethodVariantEnum.visaplatinum]: 'Visa Platinum',
  [PaymentMethodVariantEnum.visapremiumcredit]: 'Visa Premium Credit',
  [PaymentMethodVariantEnum.visapremiumdebit]: 'Visa Premium Debit',
  [PaymentMethodVariantEnum.visaprepaidanonymous]: 'Visa Prepaid Anonymous',
  [PaymentMethodVariantEnum.visaproprietary]: 'Visa Proprietary',
  [PaymentMethodVariantEnum.visapurchasing]: 'Visa Purchasing',
  [PaymentMethodVariantEnum.visapurchasingcredit]: 'Visa Purchasing Credit',
  [PaymentMethodVariantEnum.visapurchasingdebit]: 'Visa Purchasing Debit',
  [PaymentMethodVariantEnum.visasaraivacard]: 'Visa Saraiva Card',
  [PaymentMethodVariantEnum.visasignature]: 'Visa Signature',
  [PaymentMethodVariantEnum.visastandardcredit]: 'Visa Standard Credit',
  [PaymentMethodVariantEnum.visastandarddebit]: 'Visa Standard Debit',
  [PaymentMethodVariantEnum.visasuperpremiumcredit]: 'Visa Super Premium Credit',
  [PaymentMethodVariantEnum.visasuperpremiumdebit]: 'Visa Super Premium Debit',
  [PaymentMethodVariantEnum.electron]: 'Visa Electron',
  [PaymentMethodVariantEnum.electron_amazonpay]: 'Amazon Pay - Visa Electron',
  [PaymentMethodVariantEnum.electron_applepay]: 'Apple Pay - Visa Electron',
  [PaymentMethodVariantEnum.electron_samsungpay]: 'Samsung Pay - Visa Electron',
  [PaymentMethodVariantEnum.electron_vipps]: 'Vipps - Visa Electron',
  [PaymentMethodVariantEnum.electron_mobilepay]: 'MobilePay - Visa Electron',
  [PaymentMethodVariantEnum.interac]: 'Interac(online banking)',
  [PaymentMethodVariantEnum.interac_applepay]: 'Apple Pay - Interac (in-app)',
  [PaymentMethodVariantEnum.interac_googlepay]: 'Google Pay - Interac (in-app)',
  [PaymentMethodVariantEnum.paypal_pos]: 'PayPal for POS',
  [PaymentMethodVariantEnum.paysafecard]: 'PaySafeCard',
  [PaymentMethodVariantEnum.ach]: 'ACH',
  [PaymentMethodVariantEnum.ach_plaid]: 'ACH Plaid',
  [PaymentMethodVariantEnum.amex]: 'American Express',
  [PaymentMethodVariantEnum.discover]: 'Discover',
  [PaymentMethodVariantEnum.mc]: 'Mastercard',
  [PaymentMethodVariantEnum.mcdebit]: 'Mastercard Debit',
  [PaymentMethodVariantEnum.visa]: 'Visa',
  [PaymentMethodVariantEnum.visadebit]: 'Visa debit card',
  [PaymentMethodVariantEnum.vpay]: 'V Pay',
  [PaymentMethodVariantEnum.interac_card]: 'Interac Debit for POS',
  [PaymentMethodVariantEnum.paypal]: 'PayPal',
};

export const paymentMethodVariants = Object.values(PaymentMethodVariantEnum);

export const paymentMethodVariantToExtendedPaymentMethodEnumMap: Record<
  PaymentMethodVariantType,
  ExtendedPaymentMethodType
> = {
  // ACH / bank
  [PaymentMethodVariantEnum.ach]: ExtendedPaymentMethodEnum.ACH,
  [PaymentMethodVariantEnum.ach_plaid]: ExtendedPaymentMethodEnum.ACH,

  // Amex
  [PaymentMethodVariantEnum.amex]: ExtendedPaymentMethodEnum.Amex,
  [PaymentMethodVariantEnum.amex_amazonpay]: ExtendedPaymentMethodEnum.Amex,
  [PaymentMethodVariantEnum.amex_googlepay]: ExtendedPaymentMethodEnum.Googlepay,
  [PaymentMethodVariantEnum.amex_applepay]: ExtendedPaymentMethodEnum.Applepay,
  [PaymentMethodVariantEnum.amex_samsungpay]: ExtendedPaymentMethodEnum.Amex,
  [PaymentMethodVariantEnum.amex_vipps]: ExtendedPaymentMethodEnum.Vipps,
  [PaymentMethodVariantEnum.amex_mobilepay]: ExtendedPaymentMethodEnum.Mobilepay,
  [PaymentMethodVariantEnum.amexcommercial]: PaymentMethodSetupInfo.TypeEnum.Amex,
  [PaymentMethodVariantEnum.amexconsumer]: PaymentMethodSetupInfo.TypeEnum.Amex,
  [PaymentMethodVariantEnum.amexcorporate]: PaymentMethodSetupInfo.TypeEnum.Amex,
  [PaymentMethodVariantEnum.amexdebit]: PaymentMethodSetupInfo.TypeEnum.Amex,
  [PaymentMethodVariantEnum.amexprepaid]: PaymentMethodSetupInfo.TypeEnum.Amex,
  [PaymentMethodVariantEnum.amexprepaidreloadable]: PaymentMethodSetupInfo.TypeEnum.Amex,
  [PaymentMethodVariantEnum.amexsmallbusiness]: PaymentMethodSetupInfo.TypeEnum.Amex,

  // Discover
  [PaymentMethodVariantEnum.discover]: PaymentMethodSetupInfo.TypeEnum.Discover,
  [PaymentMethodVariantEnum.discover_amazonpay]: PaymentMethodSetupInfo.TypeEnum.Discover,
  [PaymentMethodVariantEnum.discover_googlepay]: PaymentMethodSetupInfo.TypeEnum.Googlepay,
  [PaymentMethodVariantEnum.discover_applepay]: PaymentMethodSetupInfo.TypeEnum.Applepay,
  [PaymentMethodVariantEnum.discover_samsungpay]: PaymentMethodSetupInfo.TypeEnum.Discover,

  // MasterCard (mc)
  [PaymentMethodVariantEnum.mc]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mc_amazonpay]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mc_googlepay]: PaymentMethodSetupInfo.TypeEnum.Googlepay,
  [PaymentMethodVariantEnum.mc_applepay]: PaymentMethodSetupInfo.TypeEnum.Applepay,
  [PaymentMethodVariantEnum.mc_samsungpay]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mc_vipps]: PaymentMethodSetupInfo.TypeEnum.Vipps,
  [PaymentMethodVariantEnum.mc_mobilepay]: PaymentMethodSetupInfo.TypeEnum.Mobilepay,
  [PaymentMethodVariantEnum.mcalphabankbonus]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mcatm]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mccommercialcredit]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mccommercialdebit]: PaymentMethodSetupInfo.TypeEnum.Mcdebit,
  [PaymentMethodVariantEnum.mccommercialpremiumcredit]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mccommercialpremiumdebit]: PaymentMethodSetupInfo.TypeEnum.Mcdebit,
  [PaymentMethodVariantEnum.mccorporate]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mccorporatecredit]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mccorporatedebit]: PaymentMethodSetupInfo.TypeEnum.Mcdebit,
  [PaymentMethodVariantEnum.mccredit]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mcdebit]: PaymentMethodSetupInfo.TypeEnum.Mcdebit,
  [PaymentMethodVariantEnum.mcfleetcredit]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mcfleetdebit]: PaymentMethodSetupInfo.TypeEnum.Mcdebit,
  [PaymentMethodVariantEnum.mcpremiumcredit]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mcpremiumdebit]: PaymentMethodSetupInfo.TypeEnum.Mcdebit,
  [PaymentMethodVariantEnum.mcprepaidanonymous]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mcpro]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mcpurchasingcredit]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mcpurchasingdebit]: PaymentMethodSetupInfo.TypeEnum.Mcdebit,
  [PaymentMethodVariantEnum.mcstandardcredit]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mcstandarddebit]: PaymentMethodSetupInfo.TypeEnum.Mcdebit,
  [PaymentMethodVariantEnum.mcsuperpremiumcredit]: PaymentMethodSetupInfo.TypeEnum.Mc,
  [PaymentMethodVariantEnum.mcsuperpremiumdebit]: PaymentMethodSetupInfo.TypeEnum.Mcdebit,

  // Visa
  [PaymentMethodVariantEnum.visa]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visa_amazonpay]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visa_googlepay]: PaymentMethodSetupInfo.TypeEnum.Googlepay,
  [PaymentMethodVariantEnum.visa_applepay]: PaymentMethodSetupInfo.TypeEnum.Applepay,
  [PaymentMethodVariantEnum.visa_samsungpay]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visa_vipps]: PaymentMethodSetupInfo.TypeEnum.Vipps,
  [PaymentMethodVariantEnum.visa_mobilepay]: PaymentMethodSetupInfo.TypeEnum.Mobilepay,
  [PaymentMethodVariantEnum.visaalphabankbonus]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visabusiness]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visacheckout]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visaclassic]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visacommercialcredit]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visacommercialdebit]: PaymentMethodSetupInfo.TypeEnum.Visadebit,
  [PaymentMethodVariantEnum.visacommercialpremiumcredit]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visacommercialpremiumdebit]: PaymentMethodSetupInfo.TypeEnum.Visadebit,
  [PaymentMethodVariantEnum.visacommercialsuperpremiumcredit]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visacommercialsuperpremiumdebit]:
    PaymentMethodSetupInfo.TypeEnum.Visadebit,
  [PaymentMethodVariantEnum.visacorporate]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visacorporatecredit]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visacorporatedebit]: PaymentMethodSetupInfo.TypeEnum.Visadebit,
  [PaymentMethodVariantEnum.visacredit]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visadankort]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visadankort_mobilepay]: PaymentMethodSetupInfo.TypeEnum.Mobilepay,
  [PaymentMethodVariantEnum.visadebit]: PaymentMethodSetupInfo.TypeEnum.Visadebit,
  [PaymentMethodVariantEnum.visafleetcredit]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visafleetdebit]: PaymentMethodSetupInfo.TypeEnum.Visadebit,
  [PaymentMethodVariantEnum.visagold]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visahipotecario]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visaplatinum]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visapremiumcredit]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visapremiumdebit]: PaymentMethodSetupInfo.TypeEnum.Visadebit,
  [PaymentMethodVariantEnum.visaprepaidanonymous]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visaproprietary]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visapurchasing]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visapurchasingcredit]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visapurchasingdebit]: PaymentMethodSetupInfo.TypeEnum.Visadebit,
  [PaymentMethodVariantEnum.visasaraivacard]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visasignature]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visastandardcredit]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visastandarddebit]: PaymentMethodSetupInfo.TypeEnum.Visadebit,
  [PaymentMethodVariantEnum.visasuperpremiumcredit]: PaymentMethodSetupInfo.TypeEnum.Visa,
  [PaymentMethodVariantEnum.visasuperpremiumdebit]: PaymentMethodSetupInfo.TypeEnum.Visadebit,

  // V PAY
  [PaymentMethodVariantEnum.vpay]: PaymentMethodSetupInfo.TypeEnum.Vpay,

  // Visa Electron (treated as Visa debit)
  [PaymentMethodVariantEnum.electron]: PaymentMethodSetupInfo.TypeEnum.Visadebit,
  [PaymentMethodVariantEnum.electron_amazonpay]: PaymentMethodSetupInfo.TypeEnum.Visadebit,
  [PaymentMethodVariantEnum.electron_applepay]: PaymentMethodSetupInfo.TypeEnum.Applepay,
  [PaymentMethodVariantEnum.electron_samsungpay]: PaymentMethodSetupInfo.TypeEnum.Visadebit,
  [PaymentMethodVariantEnum.electron_vipps]: PaymentMethodSetupInfo.TypeEnum.Vipps,
  [PaymentMethodVariantEnum.electron_mobilepay]: PaymentMethodSetupInfo.TypeEnum.Mobilepay,

  // Interac
  [PaymentMethodVariantEnum.interac]: PaymentMethodSetupInfo.TypeEnum.InteracCard,
  [PaymentMethodVariantEnum.interac_applepay]: PaymentMethodSetupInfo.TypeEnum.Applepay,
  [PaymentMethodVariantEnum.interac_card]: PaymentMethodSetupInfo.TypeEnum.InteracCard,
  [PaymentMethodVariantEnum.interac_googlepay]: PaymentMethodSetupInfo.TypeEnum.Googlepay,

  // PayPal
  [PaymentMethodVariantEnum.paypal]: PaymentMethodSetupInfo.TypeEnum.Paypal,
  [PaymentMethodVariantEnum.paypal_pos]: PaymentMethodSetupInfo.TypeEnum.Paypal,

  // Paysafecard → treat as a gift card
  [PaymentMethodVariantEnum.paysafecard]: PaymentMethodSetupInfo.TypeEnum.TodoGiftcard,

  // UK Direct Debit
  [PaymentMethodVariantEnum.directdebit_GB]: PaymentMethodSetupInfo.TypeEnum.DirectdebitGb,
};
